<template>
  <section class="min-h-screen bg-background text-primary px-6 py-10">
    <div class="mx-auto max-w-4xl card-primary space-y-6">
      <h1 class="text-3xl font-bold text-gold">CGU</h1>
      <p class="text-sm text-secondary">Version: 2026-07-17</p>

      <div class="space-y-5 text-sm leading-6 text-secondary">
        <div>
          <h2 class="text-gold font-semibold">1. Objet</h2>
          <p>
            Les presentes CGU regissent l acces et l utilisation du service Quiestleplusriche,
            exploite par TEIXEIRA Philippe, micro-entreprise.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">2. Description du service</h2>
          <p>
            Le service permet aux utilisateurs de disposer d un compte, de consulter leur position
            dans les classements et d augmenter leur score via des achats de points selon les CGV.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">3. Creation de compte</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>L utilisateur s engage a fournir des informations exactes et a jour.</li>
            <li>Chaque utilisateur est responsable de la confidentialite de ses identifiants.</li>
            <li>Le compte est personnel et ne peut pas etre cede sans autorisation.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">4. Regles d usage</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Interdiction de toute tentative de fraude, contournement technique ou usage abusif.</li>
            <li>Interdiction d usurper l identite d un tiers.</li>
            <li>Interdiction de toute utilisation portant atteinte au service ou aux autres utilisateurs.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">5. Classements</h2>
          <p>
            Les classements sont calcules automatiquement selon les regles techniques du service.
            En cas d egalite de score, l ordre est determine selon la logique de priorite appliquee par le systeme.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">6. Suspension et suppression</h2>
          <p>
            En cas de non-respect des presentes CGU, l exploitant peut suspendre ou supprimer un compte,
            de maniere temporaire ou definitive, en fonction de la gravite des faits constates.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">7. Responsabilite</h2>
          <p>
            L exploitant met en oeuvre les moyens raisonnables pour assurer la disponibilite du service,
            sans garantir l absence totale d interruption, de bug ou d indisponibilite ponctuelle.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">8. Propriete intellectuelle</h2>
          <p>
            Tous les elements du service (code, marque, contenus, design) sont proteges.
            Toute reproduction non autorisee est interdite.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">9. Donnees personnelles</h2>
          <p>
            Les traitements de donnees personnelles sont decrits dans la Politique de confidentialite.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">10. Droit applicable</h2>
          <p>
            Les presentes CGU sont soumises au droit francais. En cas de litige,
            les parties rechercheront une solution amiable avant toute action judiciaire.
          </p>
          <p>
            Toute reclamation peut etre adressee a l adresse suivante: contact@quiestleplusriche.com.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
